<template>
  <div class="liste-aides">
    <div v-for="aide in aides" :key="aide.id" class="aide" @click="$emit('click-aide', aide.id)">
      <div class="label-wrapper">
        <p class="aide-label">
          {{ aide.libelle }}
        </p>
        <p class="programme-label">
          {{ aide.libelle_programme }}
        </p>
      </div>
      <div class="infos-wrapper">
        <div class="montant-wrapper">
          <montant-aide :montant="aide.montant"></montant-aide>
        </div>
        <div class="tags-wrapper">
          <tags-aide :tags="aide.indicateurs"></tags-aide>
        </div>
      </div>
      <div class="arrow-wrapper">
        <img src="../../assets/pictos/right-arrow.svg">
      </div>
    </div>
    <message v-if="aides.length === 0">
      Aucune aides disponibles dans votre commune
    </message>
  </div>
</template>

<script>
import MontantAide from './MontantAide'
import TagsAide from './TagsAide'
import Message from '../Message'

export default {
  name: 'ListeAides',
  components: {
    MontantAide,
    TagsAide,
    Message
  },
  props: {
    aides: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.liste-aides {
  .aide {
    margin-top: $h-spacer-lg;
    background-color: #fff;
    border-radius: $radius;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    min-height: 120px;
    cursor: pointer;
    .label-wrapper {
      width: 430px;
      text-align: left;
      padding: 10px;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      .aide-label {
        font-weight: 700;
      }
    }
    .infos-wrapper {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .montant-wrapper {
        margin-right: 100px;
        width: 150px;
      }
      .tags-wrapper {
        margin-right: 70px;
      }
    }
    .arrow-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
    }
    &:hover {
      .label-wrapper, .infos-wrapper {
        background-color: $hover-color;
      }
    }
  }
}
@media (max-width:1020px) {
  .liste-aides {
    .aide {
      .label-wrapper {
        width: 50%;
      }
      .infos-wrapper {
        .montant-wrapper {
          margin-right: 20px;
        }
        .tags-wrapper {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
